<template>
  <div class="select-groups">
    <div class="row" style="margin-top: 10vh">
        <div class="col-10 ms-auto me-auto col-sm-4" style="background: white; padding: 20px; border-radius: 15px">
            <div>
              <logo style="margin-bottom: 18px"/>
            </div>
            <p style="text-align: center">
              Selecteer groepen
            </p>
            <hr>
            <div v-if="groups && groups.length > 10">
              <input
                  type="text"
                  placeholder="Zoek op naam"
                  v-model="query"
                  class="form-control"
                  style="margin-bottom: 15px"
              >
            </div>
            <div
                v-if="filteredGroups && filteredGroups.length > 0"
                class="d-grid gap-2"
            >
              <button
                v-bind:key="group.idGroup"
                v-for="group in sortArrayByProperty(filteredGroups, 'name')"
                v-on:click="selectGroup(group)"
                :class="getGroupButtonCssClassByIdGroup(group.idGroup)"
              >
                  {{ group.name }}
              </button>
            </div>
            <div v-else-if="groups && groups.length > 0">
              <p class="text-center p-padding">
                Geen resultaten...
              </p>
            </div>
            <div v-else>
              <p class="text-center p-padding">
                Geen groepen gevonden...
              </p>
            </div>
            <hr>
            <div class="d-grid gap-2">
                <button
                    v-if="localSelectedGroups.length > 0"
                    v-on:click="confirmSelection"
                    class="btn btn-info"
                >
                    Bevestig selectie
                </button>
                <button v-else class="btn btn-info" disabled="true">
                    Bevestig selectie
                </button>
                <router-link to="/select-establishment" class="btn btn-secondary">
                    Selecteer vestiging
                </router-link>
                <router-link to="/logout" class="btn btn-danger">
                    Uitloggen
                </router-link>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
export default {
  name: 'select-groups',
  components: {
    Logo
  },
  data () {
    return {
      localSelectedGroups: [],
      query: ''
    }
  },
  created () {
    this.$store.commit('SET_SHOW_SIDE_NAVBAR', false)
    this.$store.dispatch('getGroups')
    this.localSelectedGroups = this.selectedGroups || []
  },
  computed: {
    session () {
      return this.$store.getters.session
    },
    deviceToken () {
      return this.$store.getters.deviceToken
    },
    selectedEstablishment () {
      return this.$store.getters.selectedEstablishment
    },
    groups () {
      return this.$store.getters.groups
    },
    filteredGroups () {
      if (this.query !== '') {
        var groups = this.$store.getters.groups
        var self = this
        var query = this.query.toLowerCase()
        return this.$lodash().filter(groups, function (group) {
          return self.$lodash().includes(group.name.toLowerCase(), query)
        })
      } else {
        return this.$store.getters.groups
      }
    },
    selectedGroups () {
      return this.$store.getters.selectedGroups
    }
  },
  methods: {
    getIsLocalSelectedByGroupId (idGroup) {
      for (var index = 0; index < this.localSelectedGroups.length; index++) {
        if (this.localSelectedGroups[index].idGroup == idGroup) {
          return index
        }
      }
      return -1
    },
    getGroupButtonCssClassByIdGroup (idGroup) {
      if (this.getIsLocalSelectedByGroupId(idGroup) > -1) {
        return 'btn btn-info'
      }
      return 'btn btn-secondary'
    },
    selectGroup (group) {
      var index = this.getIsLocalSelectedByGroupId(group.idGroup)
      if (index > -1) {
        this.localSelectedGroups.splice(index, 1)
      } else {
        this.localSelectedGroups.push(group)
      }

    },
    confirmSelection () {
      var selectedGroups = JSON.parse(JSON.stringify(this.localSelectedGroups))
      this.$store.commit('SET_SELECTED_GROUPS', selectedGroups)
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>
</style>

<script
    setup
    lang="ts"
>
</script>